import { createSlice } from "@reduxjs/toolkit";

export const newProductSlice = createSlice({
    name: "newProduct",
    initialState: {
        newProducts: [],
        newProductsCopy: [],
        newProductDetail: {}
    },
    reducers: {
        getNewProductsReducer: (state, action) => {
            state.newProducts = action.payload;
            state.newProductsCopy = action.payload;
        },
        getNewProductByIdReducer: (state, action) => {
            const productId = action.payload;
            state.newProductDetail = state.newProducts.find(newProduct => newProduct.id === productId);
        },
        filterByBrandReducer: (state, action) => {
            const productsByBrands = state.newProducts.filter(
                newProduct => newProduct.brand === action.payload
            )
            state.newProductsCopy = action.payload === 'allBrands' ? [...state.newProducts] : productsByBrands
        },
        filterByCategoryReducer: (state, action) => {
            const producstByCategory = state.newProducts.filter(
                newProduct => newProduct.category === action.payload
            )
            state.newProductsCopy = action.payload === 'allCategories' ? [...state.newProducts] : producstByCategory
        },
        // orderByPriceReducer: (state, action) => {
        //     const newProductsOrderPrice = [...state.newProductsCopy];
            
        //     const compareAscending = (a, b) => a.price - b.price;
        
        //     const compareDescending = (a, b) => b.price - a.price;
        
        //     newProductsOrderPrice.sort(action.payload === 'A' ? compareAscending : compareDescending);
        
        //     state.newProductsCopy = newProductsOrderPrice;
        // },
    }
});

export const { getNewProductsReducer, getNewProductByIdReducer, filterByBrandReducer, filterByCategoryReducer } = newProductSlice.actions;

export default newProductSlice.reducer;